/* modal */
$(function() {
    var trigger = $('.ModalTrigger');
    var modal = $('.Modal');
    var close = $('.ModalClose');

    trigger.click(function(event) {
        event.preventDefault();
        var modal_id = $(this).data('modal');
        modal.filter('[data-modal="' + modal_id + '"]').addClass('__active');
    });

    close.click(function() {
        modal.removeClass('__active');
    });

    $('.Modal').click(function(event) {
        if (!$(event.target).closest('.modalblock-content').length) {
            $('.Modal').removeClass('__active');
        }
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            $('.Modal.__active').removeClass('__active');
        }
    });
});
